<template>
    <div>
        <flexible-content/>
        <transition name="fade" mode="out-in">
            <the-footer v-if="showContent"></the-footer>
        </transition>
    </div>
</template>

<script>
import FlexibleContent from '@/components/FlexibleContent.vue'
import TheFooter from '../components/TheFooter.vue'
export default {
    components: {
        'flexible-content': FlexibleContent,
        'the-footer': TheFooter,
    },
    metaInfo(){
        return {
            titleTemplate: null
        }
    },
    props:{
        pages: {
            type: Object,
        },
        currentPage: {
            default: 'home'
        },
        showContent: {
            type: Boolean,
            default: false
        }
    }
}
</script>

<style lang="css">
</style>
